export { ChatFragmentFragmentDoc as ChatFragment } from './chat.gql';
export { MessageFragmentFragmentDoc as MessageFragment } from './message.gql';
export { UpdateChatMessageContentFragmentDoc as UpdateChatMessageContentFragment } from './updateChatMessageContent.gql';
